import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { GROUP_TYPE, INBOX_TYPES } from '@disco/constants/GroupTypes'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { toggleShortlists } from '@disco/state-management/actions/AppActions'
import { insertItem } from '@disco/state-management/actions/ShortlistActions'
import { getShortlists } from '@disco/state-management/selectors/shortlists'
import { sendTrackDownloadEventThrottled } from '@disco/utils/eventsApi'
import type { Track } from 'types/track'
import type { RootState } from 'store/configureStore'
import { DropdownMenu } from 'components/ds'

const mapStateToProps = (state: RootState, props: OwnProps) => ({
  mobileDeviceType: state.app.mobileDeviceType,
  shortlists: getShortlists(state).filter(
    s => s.id !== props.excludeShortlistId,
  ),
  isPlaylistCreatorOpen: state.app.shortlistsOpen,
})
const mapDispatchToProps = { insertItem, sendMixpanelEvent, toggleShortlists }
const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

type OwnProps = {
  closeMenu: (...args: Array<any>) => any
  excludeShortlistId?: string
  track: Track
  sourceGroupId: number | null | undefined
  sourcePlaylistId?: number | null | undefined
  sourceGroupType: GROUP_TYPE | null | undefined
}
type Props = PropsFromRedux & OwnProps

const AddToShortlistInner = (props: Props) => {
  const navigate = useNavigate()
  const { shortlists, track } = props

  if (shortlists.length === 0) return null

  const onlyShortlist = shortlists.length === 1 ? shortlists[0] : undefined
  if (onlyShortlist) {
    return (
      <DropdownMenu.Item
        onSelect={() => {
          props.insertItem(onlyShortlist.id, { track })
          if (
            props.sourceGroupType != null &&
            INBOX_TYPES.includes(props.sourceGroupType)
          ) {
            sendTrackDownloadEventThrottled(track.id, 'in-app', {
              group_id: props.sourceGroupId,
              playlist_id: props.sourcePlaylistId,
            })
          }
          props.sendMixpanelEvent('Add track to shortlist via add to shortlist')
        }}
      >
        Playlist Creator
      </DropdownMenu.Item>
    )
  }

  const params = new URLSearchParams()
  if (props.sourceGroupId) params.set('group', String(props.sourceGroupId))
  if (props.sourcePlaylistId)
    params.set('source_playlist', String(props.sourcePlaylistId))
  if (props.excludeShortlistId)
    params.set('exclude', String(props.excludeShortlistId))
  const qs = params.toString()
  const to = `/explorer/tracks/${track.id}/add-to-shortlist${
    qs ? `?${qs}` : ''
  }`

  return (
    <DropdownMenu.Item
      onSelect={() => {
        if (!props.isPlaylistCreatorOpen) {
          const isSearchPage = window.location.pathname.includes('/search')
          props.toggleShortlists(
            true,
            isSearchPage ? 'Search' : 'Explorer',
            'Add Track to Playlist',
          )
        }
        navigate(to)
      }}
    >
      Playlist Creator
    </DropdownMenu.Item>
  )
}

export default connector(AddToShortlistInner)
